import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

let listenersAttached = false;
let currentToken = null;
let lastRegisteredClubId = null;

async function saveTokenToClub(db, appId, clubId, user, tokenValue) {
  if (!db || !appId || !clubId || !tokenValue) return;
  try {
    const tokenDocRef = doc(
      db,
      'artifacts',
      appId,
      'public',
      'data',
      'clubs',
      clubId,
      'push_tokens',
      tokenValue
    );
    await setDoc(tokenDocRef, {
      token: tokenValue,
      userId: user?.uid || null,
      userName: user?.displayName || null,
      platform: Capacitor.getPlatform(),
      clubId,
      updatedAt: serverTimestamp(),
    }, { merge: true });
    lastRegisteredClubId = clubId;
    console.log(`[PushNotifications] Saved token for club ${clubId}`);
  } catch (err) {
    console.warn('[PushNotifications] Error saving token to Firestore:', err);
  }
}

/**
 * Initializes native push notifications via Capacitor and registers device token to Firestore.
 */
export async function initPushNotifications({ db, appId, selectedClubId, user }) {
  if (!Capacitor.isNativePlatform?.()) {
    return;
  }

  // If already have a token and club changed, write token to new club
  if (currentToken && selectedClubId && selectedClubId !== lastRegisteredClubId) {
    await saveTokenToClub(db, appId, selectedClubId, user, currentToken);
  }

  if (listenersAttached) return;
  listenersAttached = true;

  try {
    // Android 8+ notification channel
    await PushNotifications.createChannel({
      id: 'match_results',
      name: 'Match Results',
      description: 'Notifications when padel matches conclude',
      importance: 5,
      visibility: 1,
      sound: 'default',
      vibration: true,
    });

    // Add listeners BEFORE registering (Capacitor best practice to avoid missed registration event)
    PushNotifications.addListener('registration', async (token) => {
      console.log('[PushNotifications] Registered with token:', token?.value);
      currentToken = token?.value || null;
      if (currentToken && selectedClubId) {
        await saveTokenToClub(db, appId, selectedClubId, user, currentToken);
      }
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.warn('[PushNotifications] Registration error:', err);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('[PushNotifications] Notification received:', notification);
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('[PushNotifications] Notification action performed:', action);
    });

    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      console.log('[PushNotifications] Permission not granted:', permStatus.receive);
      return;
    }

    await PushNotifications.register();
  } catch (e) {
    console.warn('[PushNotifications] Failed to init push notifications:', e);
  }
}
